import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Lock,
  Users,
  Settings,
  Layers,
  Activity,
  CreditCard,
  Cpu,
  Radio,
  LogOut,
  BarChart3
} from 'lucide-react';

import { useSocket } from '../contexts/SocketContext';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = () => {
  const { isConnected } = useSocket();
  const { user, logout } = useAuth();

  const navItems = [
    { path: '/register', icon: CreditCard, label: 'Register' },
    { path: '/lockers', icon: Lock, label: 'Lockers' },
    { path: '/controllers', icon: Cpu, label: 'Controllers' },
    { path: '/readers', icon: Radio, label: 'Readers' },
    { path: '/groups', icon: Layers, label: 'Groups' },
    { path: '/users', icon: Users, label: 'Users' },
    { path: '/analytics', icon: BarChart3, label: 'Analytics' },
    { path: '/heartbeat', icon: Activity, label: 'Heartbeat' },
    { path: '/settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <aside className="w-56 sidebar">
      {/* Brand */}
      <div className="px-5 pt-6 pb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-b from-primary-400 to-primary-600 flex items-center justify-center shadow-glow flex-shrink-0">
            <Lock className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-headline text-white leading-tight">Gym Lockers</h1>
            <div className="flex items-center space-x-1.5 mt-0.5">
              <span
                className={`w-1.5 h-1.5 rounded-full ${
                  isConnected ? 'bg-success-500' : 'bg-danger-500'
                }`}
              />
              <span className="text-caption text-secondary">
                {isConnected ? 'Live' : 'Offline'}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 mt-2 space-y-0.5 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center space-x-3 px-3 py-2.5 rounded-xl text-subheadline font-medium transition-all duration-200 ease-spring ${
                isActive
                  ? 'bg-primary-500/20 text-primary-300'
                  : 'text-secondary hover:text-white hover:bg-white/[0.06]'
              }`
            }
          >
            <item.icon className="w-[18px] h-[18px] flex-shrink-0" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Account / logout */}
      <div className="px-3 py-4 border-t border-white/[0.07]">
        <div className="flex items-center justify-between px-2">
          <div className="min-w-0">
            <p className="text-subheadline text-white font-medium truncate">
              {user?.username || 'Staff'}
            </p>
            <p className="text-caption text-muted capitalize">{user?.role || 'signed in'}</p>
          </div>
          <button
            onClick={logout}
            title="Sign out"
            className="p-2.5 rounded-xl text-secondary hover:text-danger-400 hover:bg-danger-500/10 transition-all duration-200"
          >
            <LogOut className="w-[18px] h-[18px]" />
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
